import { css } from '@emotion/css';

export const imageStyle = (url: string) => css`
  background-image: url(${url});
  &.grayScale {
    filter: grayscale(100%);
  }
`;

export const sessionNameRootStyles = css`
  max-width: 58rem;
`;
